<template>
  <div
    ref="detailCatalog"
    class="content-catalog"
    :style="{ visibility: cataList.length ? 'visible' : 'hidden', left: fixedLeft }"
  >
    <div v-if="!visible" class="collapse" @click="handleShow"></div>
    <div v-else ref="list" class="list">
      <div class="header">
        <span class="title">目录</span>
        <div class="close" @click="handleHide"></div>
      </div>
      <!-- 150为滚动到底部时的页脚高度 -->
      <el-scrollbar ref="elscrollbar" :wrapStyle="`max-height:${maxHeight - 180}px;min-height:200px;`">
        <div>
          <div v-for="(item, index) in cataList" :key="index">
            <h2 class="item" v-if="item.secondLevelLen <= 0">
              <div class="dot"></div>
              <div class="value" @click="handleDataId(item)">
                {{ item.title }}
              </div>
            </h2>
            <h3 class="second-item" v-else>
              <div class="dot"></div>
              <div class="value" @click="handleDataId(item)">
                {{ item.title }}
              </div>
            </h3>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import eventBus from "@/plugins/eventBus";
import { debounce } from "@/plugins/util";

export default {
  name: "ContentCatalog",
  props: {
    from: {
      type: String,
      default: ""
    },
    position: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      cataList: [],
      fixedLeft: 0,
      maxHeight: 0
    };
  },
  watch: {
    /**
     * 菜单按钮展开/收缩时，动态计算位置（绝对定位的left值）
     * @param {boolean} value
     */
    visible: "updatePosition",
    position: {
      deep: true,
      immediate: true,
      handler() {
        this.updatePosition();
        this.getMaxHeight();
      }
    }
  },
  mounted() {
    // eventBus.$on("setCataVisible", this.handleVisible);
    eventBus.$on("setCataList", this.handleList);
    // window.addEventListener("scroll", this.onScroll);
    this.getMaxHeight();
  },
  beforeDestroy() {
    // eventBus.$off("setCataVisible", this.handleVisible);
    eventBus.$off("setCataList", this.handleList);
    // window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    handleList(data) {
      this.cataList = data;
    },
    handleVisible(bool) {
      this.visible = bool;
    },
    handleShow() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    handleDataId(data) {
      const id = data.dataId;
      if (id) {
        let offsetTop = $(id).get(0).offsetTop;
        offsetTop -= 66;
        window.scrollTo({
          top: offsetTop,
          behavior: "instant"
        });
      }

      const left = this.position ? this.position.left : 0;
      /** @type {HTMLDivElement} */
      const listEl = this.$refs.list;
      if (left < listEl.clientWidth) {
        this.visible = false;
      }
    },
    /**
     * 滚动组件高度计算
     */
    getMaxHeight: debounce(function() {
      /** @type {HTMLDivElement} */
      let el = this.$refs.detailCatalog;
      if (!el) return;
      const { top } = el.getBoundingClientRect();
      this.maxHeight = window.innerHeight - top;
      this.$nextTick(() => {
        const bar = this.$refs.elscrollbar;
        bar && bar.update();
      });
    }, 300),
    async updatePosition() {
      const left = this.position ? this.position.left : 0;
      /** @type {HTMLDivElement} */
      const rootEl = this.$refs.detailCatalog;
      if (!rootEl) return;
      if (this.visible) {
        await this.$nextTick();
        /** @type {HTMLDivElement} */
        const listEl = this.$refs.list;
        if (left < listEl.clientWidth) {
          rootEl.style.left = `${left - 50}px`;
        } else {
          rootEl.style.left = `${left - listEl.clientWidth - 10}px`;
        }
      } else {
        rootEl.style.left = `${left - 50}px`;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.content-catalog {
  position: fixed;
  left: -100px;
  top: 180px;
  z-index: 99;
  .collapse {
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: url("~@/assets/images/catalog.png") center / 22px 22px no-repeat #fff;
  }
  .list {
    width: fit-content;
    min-width: 180px;
    background: #ffffff;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .header {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px 0 16px;
      border-bottom: 1px solid #ebebeb;
      .title {
        color: #333333;
        font-size: 16px;
      }
      .close {
        width: 30px;
        height: 30px;
        cursor: pointer;
        background: url("~@/assets/images/close.png") center / 20px 20px no-repeat;
      }
    }
    .item {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      padding: 0 16px;
      box-sizing: border-box;
      .dot {
        width: 6px;
        height: 6px;
        background-color: #d8d8d8;
        border-radius: 50%;
      }
      .value {
        flex: 1;
        margin-left: 10px;
        color: #333;
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
    .second-item {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      height: 28px;
      padding: 0 16px;
      padding-left: 36px;
      .left-line {
        width: 1px;
        height: 100%;
        margin-right: 5px;
        background-color: #d0d0d0;
      }
      .dot {
        width: 3px;
        height: 3px;
        background-color: #d8d8d8;
        border-radius: 50%;
      }
      .value {
        flex: 1;
        margin-left: 6px;
        color: #666;
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
  }
}
</style>
